var $       = require("jquery"),
    Project = require("../Project/Project"),
    View    = require('./View'); 

/**
 *
 * @param element
 * @param config
 * @param options
 * @return {View}
 */
module.exports = function(element, config, options){
    var configReady = $.Deferred(),
        doc_ready = $.Deferred(),
        project,
        view;

    $(doc_ready.resolve);

    if($.type(config) === 'string') {
        if (!~config.indexOf("config.json")) {
            config += "config.json";
        }

        config += "?ver=v_" + omjs.version.replace('.', '_');
        if(options && options.token){
            config += '&token=' + options.token
        }
        configReady = $.getJSON(config);
    } else if($.isPlainObject(config)) {
        configReady.resolve([config]);
    } else {
        throw new TypeError('Config should be `string` or plain object')
    }

    options || (options = {});

    return $.when(configReady, doc_ready).then(function(confResponse){
        var cfg,
            projectConf = {},
            confObject;

        confObject = confResponse[0];
        if (!$.isPlainObject(confObject)) {
            return $.Deferred().reject("Config is not a plain object");
        }

        cfg = $.extend(true, {}, confObject, options);

        // Create config for project instance
        projectConf['apiUrl'] = cfg['apiUrl'];
        projectConf['mapCode'] = cfg['mapCode'];
        projectConf['tilesUrl'] = cfg['tilesUrl'];
        projectConf['styleUrl'] = cfg['styleUrl'];

        projectConf['token'] = cfg['token'];
        projectConf['lng'] = cfg['lng'];
        projectConf['objects_editable'] = cfg['objects_editable'];
        if(cfg['token']){
            delete cfg['token'];
        }


        // Remove project options from config
        delete cfg['apiUrl'];
        delete cfg['mapCode'];

        // Create project
        project = new Project(projectConf);

        // У просмотрщиков есть зависимость от опции tilesUrl именно у view.
        cfg['tilesUrl'] = project.options['tilesUrl'];
        cfg['styleUrl'] = project.options['styleUrl'];
        // Create view
        view = new View(element, project, cfg);

        return view;
    });
};



//////////////////
// WEBPACK FOOTER
// ./src/View/viewFabric.js
// module id = 19
// module chunks = 0